import { render, staticRenderFns } from "./AssayDetail.vue?vue&type=template&id=0bcd1a0d"
import script from "./AssayDetail.vue?vue&type=script&lang=js"
export * from "./AssayDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports